import type { NotificationProps } from '../notification'

import { useNavigate } from 'react-router-dom'

import { ownAlert } from '../../alerts/actions'
import { Notification } from '../notification'

export interface AlertNotificationProps extends NotificationProps {
  id: string
  patientId: string
  clientName: string
  patientFirstName: string
  patientLastName: string
  status: string
  toLevel: string
  title: string
  place: string
  createdAt: string
}

export function AlertNotification ({
  id,
  createdAt,
  patientId,
  clientName,
  patientFirstName,
  patientLastName,
  toLevel,
  title,
  place,
  ...rest
}: AlertNotificationProps): JSX.Element {
  let navigate = useNavigate()

  let Left: React.ReactNode | undefined
  let normalizedStatus = toLevel?.trim()?.toUpperCase()

  if ([ 'L1', 'L2', 'L3', 'L4', 'L5' ].includes(normalizedStatus)) {
    Left = (
      <div
        className='w-10 aspect-square bg-red-600 flex-shrink-0 flex items-center justify-center text-white font-inter text-lg font-semibold rounded-full'
      >
        {normalizedStatus.substring(0, 2)}
      </div>
    )
  }

  return (
    <Notification
      id={id}
      date={new Date(createdAt)}
      title={`${patientFirstName} ${patientLastName}`}
      left={Left}
      onClick={() => {
        navigate(`/patient/${clientName}/${patientId}/patientFolder`)
        rest.onDismiss()
      }}
      actions={[
        {
          label: 'Own',
          onClick () {
            ownAlert(id).catch((e) => {
              console.error(e)
            })
            rest.onDismiss()
          }
        }
      ]}
      enableActionsDropdown={false}
      {...rest}
    >
      {title.replace(/ -> /g, ' → ')}
    </Notification>
  )
}
